// extracted by mini-css-extract-plugin
module.exports = {"Facebook":"_2NargtT","Instagram":"_1Yb89Mi","Snapchat":"_3rAdG8H","Vk":"_2FaCbHq"};